import './index.css'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'

import Home from './pages/home/Home'
import NotFound from './pages/notFound/NotFound'
import RemoveAccount from './pages/RemoveAccount'
import RequestRemoveAccount from './pages/RequestRemoveAccount'
import Regularizar from './pages/regularizar/Regularizar'
import RegularizarPix from './pages/regularizar/RegularizarPix'
import RegularizarToken from './pages/regularizar/RegularizarToken'
import WithoutQRCode from './pages/whitoutQRCode/WithoutQRCode'
import WithQRCode from './pages/withQRCode/WithQRCode'

export type ICities = {
  city: string
  id: number
  status: string
}

export type IArea = {
  id: number
  name: string
}

function App() {
  const router = createBrowserRouter([
    { path: '/', element: <Home /> },
    { path: '/estacionar', element: <WithoutQRCode /> },
    { path: '/estacionar/:qrcodeKey', element: <WithQRCode /> },
    { path: '/regularizar', element: <Regularizar /> },
    { path: '/regularizar/:tokenId', element: <RegularizarToken /> },
    { path: '/regularizar/pix/:qrcodeKey', element: <RegularizarPix /> },
    { path: '/solicitar-remocao-conta', element: <RequestRemoveAccount /> },
    { path: '/remocao-conta/:key', element: <RemoveAccount /> },
    { path: '*', element: <NotFound /> },
  ])

  return <RouterProvider router={router} />
}

export default App
